<template>
  <div>
    
    <div class="row">
      <div class="col-xs-12 col-6">
        <h5>Choix de tags</h5>
        <div id="about-button-container">
          <button 
          class="btn btn-sm btn-transparent" 
          @click="showAllAbouts()">Effacer la sélection</button>
          <button 
          v-for="(about, index) in getCategories()" 
          v-bind:class="'btn btn-sm ' + activeClassName(index)"
          v-bind:key="about" 
          @click="toogleActive(index)">{{about}}</button>
        </div>
      </div>
      <div class="col-xs-12 col-6">
        <h5>Choix des niveaux d'entrée</h5>
        <div id="level-button-container">
          <button 
          class="btn btn-sm btn-transparent" 
          @click="showAllLevels()">Effacer la sélection</button>
          <button 
          v-for="(level, index) in getLevels()"
          v-bind:class="'btn btn-sm ' + activeLevelName(index)" 
          v-bind:key="level" 
          @click="toogleActiveLevel(index)"
          v-html="rLevelLabel(level) + ' ' + showLevel(level)"></button>
        </div>
      </div>
    </div>



    <div class="row">
        <div 
        v-for="(training) in trainings" 
        v-bind:key="training.title" 
        v-bind:class="'col-xs-12 col-md-6 col-xl-4 training-item ' + 
          training.prg_level + ' ' + training.abouts.join(' ') +
          (isInAbout(training.abouts)&&isInLevel(training.prg_level) ? ' show ' : '')"
        >
          <div class="card mb-4 text-dark">
            <div class="card-header">
                <div class="card-title"><h5>{{training.title}}</h5></div>
            </div>
            <div class="card-body">
              <div class="card-text">
                <p><strong>En bref : </strong> {{training.summary}}</p>
              </div>  

              <div class="card-text" title="Durée en journée(s)">
                <p><strong>Durée de la formation :</strong> {{training.duration}} journée(s)</p>
              </div>
              <div class="card-text" title="Niveau R d'entrée exigé">
                <p class="level-par">
                  <strong>Niveau R d'entrée exigé: </strong>
                  <span v-html="showLevel(training.prg_level)"></span>
                </p>
              </div>
              <div class="card-text">
                <p>Le(s) pakage(s) utilisés en formation :</p>
                <div class="row">
                  <div class="col-3"
                    v-for="(tech) in training.techs" 
                    v-bind:key="tech.filename" 
                    >
                  <img 
                    v-bind:src="loadHexbin(tech.filename)"
                    v-bind:alt="tech.alternative_text"
                    style="width:100%"
                    />
                  </div>
                </div>
                <p></p>
              </div>
              <p class="text-center mt-3">
                <a 
                v-bind:href="'/formation-r/' + training.basefile"
                class="btn btn-transparent">Consulter</a>
              </p>
            </div>
          </div>
        </div>
    </div>
  </div>


</template>

<script>
import trainingsDb from '../assets/trainings.json';
import rLevels from '../assets/references.json';


export default {
  data() {
    return {
      trainings: trainingsDb,
      abouts: [],
      categories: [],
      levels: [],
      activeCategories: [],
      activeLevels: []
    };
  },
  beforeMount() {
    let s=new Set();
    this.trainings.forEach(element => {
          element.abouts.map(
            category => {s.add(category)}
          )

    });
    this.categories = Array.from(s);
    this.levels = Array.from(this.getLevels());
    this.activeCategories = new Array(this.trainings.length).fill(true);
    this.activeLevels = new Array(this.getLevels().length).fill(true);
  },
  methods: {
    loadHexbin(imgPath) {
      return window.location.origin + '/img/hexbin/' + imgPath;
    },
    showLevel(level) {
      if(level === 'beginner'){
        return '<i class="far fa-star"></i>';
      } else if(level === 'intermediate'){
        return '<i class="fas fa-star"></i>';
      } else if(level === 'advanced'){
        return '<i class="fas fa-star"></i><i class="fas fa-star"></i>';
      } else return '';
    },
    rLevelLabel(level) {
      return rLevels[level];
    },
    getCategories() {
      let s=new Set();
      this.trainings.forEach(element => {
            element.abouts.map(
              category => {s.add(category)}
            )

      });
      return  Array.from(s);
    },
    getLevels() {
      return  Object.keys(rLevels);
    },
    showAllAbouts(){
      this.activeCategories = new Array(this.trainings.length).fill(true);
    },
    showAllLevels(){
      this.activeLevels = new Array(this.levels.length).fill(true);
    },
    isInAbout(aboutArray){
      const f = (as, bs) => as.filter((_, i) => bs[i])
      const activeAboutArray = f(this.categories, this.activeCategories);
      return aboutArray.some(r=> activeAboutArray.includes(r));
    },
    isInLevel(level){
      const f = (as, bs) => as.filter((_, i) => bs[i])
      const activeLevelArray = f(this.levels, this.activeLevels);
      return [level].some(r=> activeLevelArray.includes(r));
    },
    toogleActive(index){
      this.activeCategories = new Array(this.trainings.length).fill(false);
      this.activeCategories[index] = true;
    },
    toogleActiveLevel(index){
      this.activeLevels = new Array(this.getLevels().length).fill(false);
      this.activeLevels[index] = true;
    },
    activeClassName(index){
      const out = this.activeCategories[index] ? ' btn-secondary  active' : ' btn-light';
      return out;
    },
    activeLevelName(index){
      const out = this.activeLevels[index] ? ' btn-secondary  active' : ' btn-light';
      return out;
    }
  }
}
</script>

<style scoped>
.training-item {
  display: none; /* Hide columns by default */
}

.show {
  display: block;
}



</style>
